import { SimpleEventDispatcher } from "ste-simple-events";
import { BaseCommon } from "./base-common.abstract";
import { sdkOpts } from "../../services/sdk";
export var CcpaStatus;
(function (CcpaStatus) {
    CcpaStatus["OptIn"] = "optIn";
    CcpaStatus["OptOut"] = "optOut";
    CcpaStatus["Anonymous"] = "anonymous";
})(CcpaStatus || (CcpaStatus = {}));
export class BaseStore extends BaseCommon {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "microsite", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "env", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "api_base_uri", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "primaryBlockId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "googleMaps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "adobe", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "parsely", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "comscore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ads", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "redirect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disableThirdParty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "routeParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "ampLibs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, "sdkOpts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: sdkOpts()
        });
        Object.defineProperty(this, "stackedNavState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "onIntersectAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SimpleEventDispatcher()
        });
        Object.defineProperty(this, "onAnalyticsAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SimpleEventDispatcher()
        });
        Object.defineProperty(this, "onUploadAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SimpleEventDispatcher()
        });
        Object.defineProperty(this, "onContestAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SimpleEventDispatcher()
        });
        Object.defineProperty(this, "onAuthAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SimpleEventDispatcher()
        });
        Object.defineProperty(this, "onShareAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SimpleEventDispatcher()
        });
        Object.defineProperty(this, "block", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "session", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultCategoryCatalog", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
}
//# sourceMappingURL=base-store.abstract.js.map